import { accounts } from './accounts';
import { ai } from './ai';
import { budget } from './budget';
import { categories } from './categories';
import { common } from './common';
import { creditCards } from './creditCards';
import { financings } from './financings';
import { goals } from './goals';
import { home } from './home';
import { installments } from './installments';
import { notifications } from './notifications';
import { onboarding } from './onboarding';
import { personalLoans } from './personalLoans';
import { pro } from './pro';
import { projections } from './projections';
import { receipts } from './receipts';
import { reminders } from './reminders';
import { reports } from './reports';
import { reservas } from './reservas';
import { settings } from './settings';
import { subscriptions } from './subscriptions';
import { tags } from './tags';
import { transactions } from './transactions';
import { ui } from './ui';
import { validation } from './validation';
import { widgets } from './widgets';

/**
 * Schema canônico das traduções: o pt-BR é a fonte da verdade E o fallback —
 * toda string do app nasce aqui, extraída do código exatamente como está na
 * tela hoje; os outros idiomas são parciais dele. Um namespace por área de
 * feature (espelham os diretórios de app/). Ver ADR 0044.
 */
export const ptBR = {
    accounts,
    ai,
    budget,
    categories,
    common,
    creditCards,
    financings,
    goals,
    home,
    installments,
    notifications,
    onboarding,
    personalLoans,
    pro,
    projections,
    receipts,
    reminders,
    reports,
    reservas,
    settings,
    subscriptions,
    tags,
    transactions,
    ui,
    validation,
    widgets,
};

export type TranslationSchema = typeof ptBR;
